export const CHAPTER_TIME_BUFFER = 0.05;
export const VIDEO_SEGMENT_MAX_FILE_SIZE = 1024;

export const MIN_SELECTION_SIZE = 5;

export const TIMELINE_COMPONENT_CLASS_IDENTIFIER = {
  FIXED_WIDTH_TIMELINE: 'fixed-width-timeline',
  ELEMENT_MENU_CONTAINER: 'element-menu-container',
  CHAPTER_CONTAINER: 'chapter-container'
};
